var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightTickDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.932,
    height: 26.933,
    viewBox: "0 0 26.932 26.933",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_62bc672ce0fa1d23adf660f4_check-green-icon",
    "data-name": "62bc672ce0fa1d23adf660f4_check-green-icon",
    d: "M20.271,1.356l.157.312L21.6,4.8a.909.909,0,0,0,.533.533l3.02,1.135a2.732,2.732,0,0,1,1.686,3.253l-.086.265-1.4,3.108a.91.91,0,0,0,0,.755l1.335,2.938a2.734,2.734,0,0,1-1.11,3.489l-.312.157-3.128,1.175a.913.913,0,0,0-.531.533l-1.135,3.02a2.735,2.735,0,0,1-3.255,1.686l-.265-.086-3.108-1.4a.91.91,0,0,0-.755,0l-2.936,1.335a2.734,2.734,0,0,1-3.489-1.11l-.157-.312L5.328,22.138a.912.912,0,0,0-.533-.531l-3.02-1.135A2.734,2.734,0,0,1,.09,17.218l.086-.265,1.406-3.108a.912.912,0,0,0,0-.755L.245,10.153a2.734,2.734,0,0,1,1.108-3.49l.312-.157L4.8,5.327a.912.912,0,0,0,.533-.533l1.135-3.02A2.734,2.734,0,0,1,9.715.089l.265.086,3.108,1.406a.912.912,0,0,0,.755,0L16.782.246a2.734,2.734,0,0,1,3.489,1.108Zm-2.388,7.43-6.5,7.428L9.009,13.843a.912.912,0,0,0-1.29,1.29l3.061,3.061a.912.912,0,0,0,1.331-.045l7.142-8.163a.912.912,0,0,0-1.371-1.2Z",
    transform: "translate(0 0)",
    fill: "#22ad7e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTickDark);
export default __webpack_public_path__ + "static/media/rightTickDark.2a9fed1c4b9bbd98fd8800b3b2693bd8.svg";
export { ForwardRef as ReactComponent };